import { type Enum } from '@webapp/infrastructure/types/Enum'

// Expense Status Page
export const ExpenseStatusPageTabStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  DENIED: 'denied',
  APPROVED: 'approved',
} as const

export type ExpenseStatusPageTabStatus = Enum<
  typeof ExpenseStatusPageTabStatuses
>

export interface ExpenseStatusPageParams {
  status: ExpenseStatusPageTabStatus
}

export interface ExpenseDetailsPageParams {
  uuid: uuid
}

// Expense Approvals Page
export const ExpenseApprovalsPageTabStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
} as const

export type ExpenseApprovalsPageTabStatus = Enum<
  typeof ExpenseApprovalsPageTabStatuses
>

export interface ExpenseApprovalsPageParams {
  status: ExpenseApprovalsPageTabStatus
}

// Travel Status Page
export const TravelStatusPageTabStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
} as const

export type TravelStatusPageTabStatus = Enum<typeof TravelStatusPageTabStatuses>

export interface TravelStatusPageParams {
  status: TravelStatusPageTabStatus
}

// Travel Approvals Page
export const TravelApprovalsPageTabStatuses = {
  ALL: 'all',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
} as const

export type TravelApprovalsPageTabStatus = Enum<
  typeof TravelApprovalsPageTabStatuses
>

export interface TravelApprovalsPageParams {
  status: TravelApprovalsPageTabStatus
}

// Travel Details Page
export interface TravelDetailsPageParams {
  uuid: uuid
}

// Travel Edit Page
export interface TravelEditPageParams {
  uuid: uuid
}
